<template>
  <div class="package-shipment-type mb-20">
    <div>
      <p class="label pb-4">Select Package Type</p>
    </div>
    <div
      class="truck-package"
      v-for="(item, index) in packages"
      :key="index + 'truck' + 1"
    >
      <div
        class="accordion-head flex justify-between cursor-pointer"
        @click="toggleAccordion(`accordionBodyTruckPackage${index}`)"
      >
        <div>
          <span
            ><svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.9998 0C5.37259 0 0 5.37267 0 11.9999C0 18.6269 5.37251 24 11.9996 24C18.6268 24 23.9998 18.6269 23.9998 11.9999C23.9998 5.37267 18.6269 0 11.9998 0ZM17.0622 13.3199H13.2007V17.3574C13.2004 18.0345 12.6516 18.5833 11.9744 18.5833C11.297 18.5833 10.7482 18.0345 10.7482 17.357V13.3199H6.98945C6.31218 13.3197 5.76362 12.7709 5.76322 12.0937C5.76322 11.4167 6.31226 10.8677 6.98945 10.8675L10.7481 10.8677V7.28449C10.7481 6.60721 11.2972 6.05826 11.9742 6.05826C12.6516 6.05826 13.2007 6.60729 13.2004 7.28449L13.2007 10.8674L17.0618 10.8678C17.7391 10.8674 18.2883 11.4166 18.2881 12.094C18.2883 12.7713 17.7391 13.3199 17.0622 13.3199Z"
                fill="#E59506"
              />
            </svg>
          </span>
          <span class="pl-2 font-semibold">Truck Package</span>
        </div>
        <div class="flex gap-2 items-center">
          <div v-if="validate(packages[index])" class="mr-2">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.1056 0.465598C21.6825 0.229778 21.2173 0.079812 20.7363 0.0242747C20.2554 -0.0312625 19.7683 0.00871853 19.3028 0.141932C18.8373 0.275145 18.4026 0.498978 18.0235 0.800629C17.6444 1.10228 17.3284 1.47583 17.0935 1.89992L10.2518 14.2348L6.33611 10.3121C5.99616 9.95944 5.5895 9.67817 5.13988 9.48468C4.69026 9.29119 4.20667 9.18934 3.71734 9.18508C3.228 9.18082 2.74272 9.27424 2.28981 9.45987C1.8369 9.64551 1.42543 9.91965 1.0794 10.2663C0.733379 10.6129 0.459733 11.0252 0.274433 11.4789C0.0891318 11.9326 -0.00411303 12.4188 0.000139145 12.909C0.00439132 13.3992 0.106055 13.8837 0.299199 14.3341C0.492343 14.7845 0.773097 15.1919 1.12508 15.5325L8.49571 22.9164C9.19223 23.616 10.132 24 11.1012 24L11.6116 23.9631C12.1765 23.8839 12.7153 23.6745 13.1857 23.3513C13.656 23.0281 14.0451 22.5999 14.3222 22.1005L23.5355 5.48666C23.7707 5.06292 23.9203 4.59691 23.9757 4.11525C24.0312 3.63358 23.9914 3.14569 23.8586 2.67944C23.7258 2.21319 23.5027 1.7777 23.2019 1.39785C22.9011 1.01799 22.5286 0.701215 22.1056 0.465598Z"
                fill="#09B78A"
              />
            </svg>
          </div>
          <div v-if="packages.length > 1" @click="deletePackage(index)">
            <remove-icon />
          </div>
          <div v-else>
            <img src="@/assets/images/icons/delete.svg" alt="delete icon" />
          </div>
        </div>
      </div>

      <div
        :ref="`accordionBodyTruckPackage${index}`"
        class="container-fluid accordion-body light-package-form"
      >
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="input-wrapper">
              <label class="label">Truck Capacity <span class="text-red-500">*</span></label>
              <el-select v-model="item.truckCapacity" placeholder="Special ">
                <el-option
                  v-for="option in truckCapacities"
                  :key="option"
                  :label="option"
                  :value="option"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="input-wrapper">
              <label class="label">Shipmment Category <span class="text-red-500">*</span></label>
              <el-select v-model="item.shipmentCategory" placeholder="Special ">
                <el-option
                  v-for="option in shipmentCategories"
                  :key="option"
                  :label="option"
                  :value="option"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="input-wrapper">
              <label class="label">Shipment Description <span class="text-red-500">*</span></label>
              <input
                type="text"
                class="input"
                placeholder="Describe its content"
                v-model="item.description"
              />
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="input-wrapper">
              <label class="label">Package Type <span class="text-red-500">*</span></label>
              <label class="radio-label float-right">
                <input
                  type="radio"
                  :id="`yes${index}`"
                  value="yes"
                  v-model="item.specialHandlingRadio"
                />
                All items are of a similar dimension
                <span></span>
              </label>
              <el-select
                v-model="item.packageType"
                placeholder="Package Type"
              >
                <el-option
                  v-for="option in packageTypes"
                  :key="option"
                  :label="option"
                  :value="option"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="input-wrapper">
              <label class="label">Quantity <span class="text-red-500">*</span></label>
              <input
                type="text"
                class="input"
                placeholder="Enter Quantity"
                :disabled="$route.query.consolidationId"
                v-model="item.quantity"
              />
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="input-wrapper">
              <label class="label">Package Dimension</label>
              <span class="float-right font-normal text-sm">(Optional)</span>
              <div>
                <base-input
                  style="width: 69px"
                  class="float-left font-size-normal"
                  type="text"
                  name="dimension"
                  v-model="item.length"
                  placeholder="-L-"
                  required="true"
                  error="Enter a Dimension"
                >
                </base-input>
                <span class="float-left mt-2" style="color: #cbd2dd">*</span>
                <base-input
                  style="width: 69px"
                  class="float-left font-size-normal"
                  type="text"
                  name="dimension"
                  v-model="item.width"
                  placeholder="-W-"
                  required="true"
                  error="Enter a Dimension"
                >
                </base-input>
                <span class="float-left mt-2" style="color: #cbd2dd">*</span>

                <base-input
                  style="width: 69px"
                  class="float-left font-size-normal"
                  type="text"
                  name="dimension"
                  v-model="item.height"
                  placeholder="-H-"
                  required="true"
                  error="Enter a Dimension"
                >
                </base-input>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="input-wrapper">
              <label class="label">Total Estimated Weight (kg)</label>
              <span class="float-right font-normal text-sm">(Optional)</span>
              <input
                type="text"
                class="input"
                placeholder="Enter Esitmated Weight"
                :disabled="$route.query.consolidationId"
                v-model="item.estimatedWeight"
              />
              <i class="font-normal text-sm"
                >Total Shipment cost is subject to weight confirmation by our
                agent</i
              >
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="input-wrapper">
              <label class="label">Value <span class="text-red-500">*</span></label>
              <b-input-group prepend="NGN" append=".00">
                <b-form-input
                  type="text"
                  class="input"
                  placeholder="Enter item value"
                  :disabled="$route.query.consolidationId"
                  v-model="item.itemValue"
                ></b-form-input>
              </b-input-group>
              <i class="font-normal text-sm"
                >Your shipment will be insured to the tune of the value
                declared</i
              >
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="input-wrapper special-handling">
              <div class="flex gap-4">
                <label class="label">Special handling? <span class="text-red-500">*</span></label>
                <div class="flex">
                  <label class="radio-label" :for="`yes${index}`">
                    <input
                      type="radio"
                      :id="`yes${index}`"
                      value="yes"
                      v-model="item.specialHandlingRadio"
                    />
                    Yes
                    <span></span>
                  </label>
                  <label class="radio-label ml-4" :for="`no${index}`">
                    <input
                      type="radio"
                      :id="`no${index}`"
                      value="no"
                      v-model="item.specialHandlingRadio"
                    />
                    No
                    <span></span>
                  </label>
                </div>
              </div>
              <el-select
                v-model="item.specialHandling"
                :disabled="item.specialHandlingRadio == 'no'"
                multiple
                placeholder="Special handling options"
              >
                <el-option
                  v-for="option in handlingOptions"
                  :key="option"
                  :label="option"
                  :value="option"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="add-package-btn" @click="addNewPackage">
              <div>
                <span
                  ><svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.9998 0C5.37259 0 0 5.37267 0 11.9999C0 18.6269 5.37251 24 11.9996 24C18.6268 24 23.9998 18.6269 23.9998 11.9999C23.9998 5.37267 18.6269 0 11.9998 0ZM17.0622 13.3199H13.2007V17.3574C13.2004 18.0345 12.6516 18.5833 11.9744 18.5833C11.297 18.5833 10.7482 18.0345 10.7482 17.357V13.3199H6.98945C6.31218 13.3197 5.76362 12.7709 5.76322 12.0937C5.76322 11.4167 6.31226 10.8677 6.98945 10.8675L10.7481 10.8677V7.28449C10.7481 6.60721 11.2972 6.05826 11.9742 6.05826C12.6516 6.05826 13.2007 6.60729 13.2004 7.28449L13.2007 10.8674L17.0618 10.8678C17.7391 10.8674 18.2883 11.4166 18.2881 12.094C18.2883 12.7713 17.7391 13.3199 17.0622 13.3199Z"
                      fill="#E59506"
                    />
                  </svg>
                </span>
                <span class="pl-2 font-semibold cursor-pointer"
                  >Save and Add Another</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <delete-modal
      :show-modal="isDeleteModal"
      @close-modal="isDeleteModal = false"
      :itemToDelete="selectedPackage"
      @delete-item="removePackage"
    />
  </div>
</template>

<script>
import DeleteModal from "@/components/UI/Modal/DeleteModal";

export default {
  components: {
    DeleteModal,
  },
  props: ["packageSavedCount", "preWeight", "preValue"],
  data() {
    return {
      packages: [
        {
          shipmentType: "truck",
          truckCapacity: "",
          shipmentCategory: "",
          quantity: "",
          length: null,
          width: null,
          height: null,
          estimatedWeight: "",
          packageType: "",
          description: "",
          itemValue: "",
          specialHandlingRadio: "no",
          specialHandling: [],
          shippingId: this.$store.getters.shippingId,
        },
      ],
      selectedPackageIndex: null,
      selectedPackage: "",
      isDeleteModal: false,
      isLoading: false,
      handlingOptions: [
        "Fragile",
        "Over-sized",
        "Over-weight",
        "Flammable",
        "Radioactive",
      ],
      packageTypes: ["Boxed", "Sacked", "Crated", "Pallets"],
      truckCapacities: [
        "5 Ton",
        "10 Ton",
        "15 Ton",
        "20 Ton Flat Bed",
        "20 Ton Sided",
        "30 Ton Flat Bed",
        "30 Ton Sided",
        "40 Ton Flat Bed",
        "40 Ton Sided",
        "20ft Container",
        "40ft Container",
      ],
      shipmentCategories: [
        "Clothings/Shoes",
        "Computer Accessories",
        "Electronics",
        "Food",
        "Phone",
        "Jewelries/Accessories",
        "Health Products",
        "Others",
      ],
      selectedHandlingOptions: [],
    };
  },
  watch: {
    isNewConsignee(val) {
      if (val) {
        this.packages = [
          {
            shipmentType: "truck",
            truckCapacity: "",
            shipmentCategory: "",
            quantity: "",
            length: null,
            width: null,
            height: null,
            esimatedWeight: "",
            packageType: "",
            description: "",
            itemValue: "",
            specialHandlingRadio: "no",
            specialHandling: [],
            shippingId: this.$store.getters.shippingId,
          },
        ];
      }
    },
    packageSavedCount(val, oldval) {
      if (val > oldval) {
        this.packages = this.$store.state.bookingModule.packages;
      }
    },
  },
  computed: {
    isNewConsignee() {
      return this.$store.getters.isNewConsignee;
    },
  },
  mounted() {
    this.packages[0].shippingId = this.$store.getters.shippingId;

    let accordionBody = this.$refs["accordionBodyTruckPackage0"][0];
    accordionBody.style.maxHeight = accordionBody.scrollHeight + 100 + "px";

    if (this.$route.query.consolidationId) {
      this.packages[0].estimatedWeight = this.preWeight;
      this.packages[0].itemValue = this.preValue;
      this.packages[0].quantity = 1;
    }
  },
  methods: {
    toggleAccordion(ref) {
      let accordionBody = this.$refs[ref][0];
      if (accordionBody.style.maxHeight) {
        accordionBody.style.maxHeight = null;
        accordionBody.style.marginBottom = null;
      } else {
        accordionBody.style.maxHeight = accordionBody.scrollHeight + 100 + "px";
        accordionBody.style.marginBottom = "2rem";
      }
      this.isAccordionBody = !this.isAccordionBody;
    },
    addNewPackage() {
      const newPackage = {
        shipmentType: "truck",
        truckCapacity: "",
        shipmentCategory: "",
        quantity: "",
        length: null,
        width: null,
        height: null,
        estimatedWeight: "",
        packageType: "",
        description: "",
        itemValue: "",
        specialHandlingRadio: "no",
        specialHandling: [],
        shippingId: this.$store.getters.shippingId,
      };
      this.packages.push(newPackage);
    },
    returnPayload() {
      const totalPackages = this.packages;
      const filteredTotalPackages = [...totalPackages];
      return filteredTotalPackages;
    },
    deletePackage(index) {
      this.selectedPackageIndex = index;
      this.isDeleteModal = true;
    },
    removePackage() {
      if (this.selectedPackageIndex != null) {
        this.packages.splice(this.selectedPackageIndex, 1);
      }
      this.isDeleteModal = false;
    },
    validate(object_) {
      var errors = Object.keys(object_)
        .filter(function (key) {
          if (key != "specialHandling") return object_[key] == "";
          else return false;
        })
        .map(function (key) {
          return new Error(key + " is invalid.");
        });

      if (errors.length > 0) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.accordion-head {
  background: #fbfcfe;
  border: 1px solid #dae8f6;
  box-sizing: border-box;
  border-radius: 2px;
  padding: 0.5rem 0.75rem;
}

.accordion-body {
  max-height: 0;
  overflow: hidden;
  transition: all ease 0.5s;
  margin: 1rem 0;
}

svg {
  display: inline-block;
}

.label {
  color: var(--primaryblue);
  font-size: 0.9rem;
  font-weight: 500;
}

p {
  color: var(--primaryblue);
  /* margin-left: 1.2rem; */
}

.check-label {
  font-size: 0.9rem;
}

.input {
  background: #fbfcfe;
  border: 1px solid #dae8f6;
  box-sizing: border-box;
  backdrop-filter: blur(6px);
  border-radius: 2px;
}

.input::placeholder {
  color: #bec4d5;
}

/* .input-wrapper {
  width: 90%;
  margin: 0 auto 2rem;
} */
.input-wrapper.special-handling,
.package-type {
  width: 100%;
}

.add-package-btn {
  cursor: pointer;
  background: #fbfcfe;
  border: 1px solid #dae8f6;
  box-sizing: border-box;
  border-radius: 2px;
  padding: 1rem;
  margin: 2rem 0;

  span {
    color: var(--amber);
  }
}

svg {
  display: inline-block;
}
</style>
